import { useEffect, useRef } from 'react';

// The ONE persistent rotation loop. Started once; never restarted by RPM
// or play-state changes -- those are read live from refs every frame, so
// changing the RPM slider never triggers a React re-render of the canvas.
export function useRotationLoop(discCanvasRef, rpmRef, getIsPlaying) {
  const rafRef = useRef(null);
  const lastFrameRef = useRef(null);
  const rotationDegRef = useRef(0);

  useEffect(() => {
    function loop(now) {
      if (lastFrameRef.current == null) lastFrameRef.current = now;
      const delta = (now - lastFrameRef.current) / 1000;
      lastFrameRef.current = now;

      if (getIsPlaying()) {
        rotationDegRef.current += (rpmRef.current / 60) * 360 * delta;
        rotationDegRef.current %= 360;
      }
      const el = discCanvasRef.current;
      if (el) {
        el.style.transform = `translate(-50%, -50%) rotate(${rotationDegRef.current}deg)`;
      }
      rafRef.current = requestAnimationFrame(loop);
    }
    rafRef.current = requestAnimationFrame(loop);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      lastFrameRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
